(function() {
	'use strict';
	angular.module('app.core')
		.service('reportsExportService', reportsExportService);
	
	reportsExportService.$inject = ['URLS'];
	
	function reportsExportService(URLS) {
		return {
			startDownload: startDownload
		};
		
		function startDownload(factoryId, reportId, modalInstance, callback) {
			var url = URLS.host + URLS.prefix + factoryId + '/ExportRequest/' + reportId;
			jQuery.fileDownload(url, {
				successCallback: function(url) {
					if (modalInstance) modalInstance.close();
					callback('Downloading...', true);
				},
				failCallback: function(responseHtml, url, error) {
					if (modalInstance) modalInstance.close();
					callback(responseHtml, false);
				}
			});
		}
	}
})();